module.exports = __webpack_public_path__ + "static/media/Asset 9RHip.7b7bda40.png";